import createLucideIcon from '../createLucideIcon';

const AlignCenter = createLucideIcon('AlignCenterIcon', [
  ['line', { x1: '21', y1: '6', x2: '3', y2: '6', key: '1e448z' }],
  ['line', { x1: '17', y1: '12', x2: '7', y2: '12', key: 'driibe' }],
  ['line', { x1: '19', y1: '18', x2: '5', y2: '18', key: '1i3xdx' }],
]);

export default AlignCenter;
